import { CompanyId } from './company-id'
import { CompanyName } from './company-name'

export const companyNameById = {
  [CompanyId.NATURA]: CompanyName.NATURA,
  [CompanyId.AVON]: CompanyName.AVON,
}
